import { css } from '@emotion/react';

const rootDocumentStyles = css`
    @keyframes loading {
        0% {
            left: 0;
            width: 20%;
        }

        100% {
            left: 100%;
            width: 80%;
        }
    }

    .status-bar {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
    }

    .loading-bar {
        background: #bababa;
        height: 0.25em;
        overflow: hidden;

        .progress-segment {
            position: absolute;
            background: #5cd790;
            width: 20%;
            height: 100%;
            animation: loading 1s linear infinite;
        }

        &.is-error {
            background: $color-error;
        }
    }

    .running-header-edit-mode,
    .running-footer-edit-mode {
        position: relative;
        padding: 1rem 0;

        .border {
            border-bottom: 1px dotted grey;
            position: absolute;
            top: 25px;
            width: 100%;
            z-index: 0;
        }

        span {
            background-color: white;
            border: 1px solid grey;
            border-radius: 5px;
            margin-left: 1rem;
            position: relative;
            z-index: 1;
            padding: 0px 5px;
        }
    }
`;

export default rootDocumentStyles;
